import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BuyCartItemType } from '../types/type';

// Define the user structure
interface User {
    // Define the structure of your user object
    permissions: [],
}

// Define the initial state
export interface UserState {
    user: User | null;
    permissions: any,
    edit_permission: any,
    buy_cart_items: BuyCartItemType[] | null
    ri_cart_items: BuyCartItemType[] | null
}

const initialState: UserState = {
    user: null,
    permissions: [],
    edit_permission: {},
    buy_cart_items: null,
    ri_cart_items: null
};

// Create the user slice
const userSlice = createSlice({
    name: 'User',
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<User | null>) {
            console.log(action.payload?.permissions)
            state.user = action.payload;
            state.permissions = action.payload?.permissions.map((data: any) => {
                state.edit_permission[data?._resources?.resource_name] = data?.can_edit;
                return data?._resources?.resource_name;
            });
        },
        updateBuyCart: (state, action) => {
            state.buy_cart_items = action.payload
        },
        updateRentCart: (state, action) => {
            state.ri_cart_items = action.payload
        },
        logout(state) {
            state.user = null;
            localStorage.removeItem("token")
        },

    },
});

// Export the action creators
export const { setUser, logout, updateBuyCart, updateRentCart } = userSlice.actions;

// Export the reducer
export default userSlice.reducer;
